import React from 'react';
import Card from "../Widgets/Card";
import ProductGrid from "../Widgets/grid";
import Grid from '@material-ui/core/Grid';
import SectionHeading from "../Widgets/section-head";

// style sheet
import "./products.css";

// @ts-ignore
import products from "../../json-placeholders/product-data.json";

const Product = ({ addToCart, addToWish, heading, deleteIcon = false }) => {
    const CardGrid = () => {
        let count = 0;
        const data = products.map(item => {
            count++;
            return (
                <Grid style={{}} key={count} item xs={10} sm={5} md={4} lg={4} xl={3} className="grid-item">
                    <Card 
                        // @ts-ignore
                        className="product-card"
                        key={item.id}
                        data={item}
                        addToCart={ addToCart }
                        addToWish={ addToWish }
                        deleteIcon={ deleteIcon }
                         />
                </Grid>
            )
        })
        return data;
    }

    return (
        <div className="products-container">
            <SectionHeading text={ heading ?? "Section heading" } color="black" margin="0 0 2rem 3rem" />
            <ProductGrid children={
                <CardGrid />
            } />
        </div>
    )
}

export default Product;